import { alpha, type Theme } from '@mui/material/styles'

export const getStepColor = (theme: Theme, isActive: boolean) => {
  if (isActive) return 'success.main'

  return alpha(theme.palette.success.main, 0.12)
}

export const getStepStyles = (theme: Theme, completed: boolean, allCompleted: boolean) => {
  const activeColor = allCompleted ? theme.palette.success.main : theme.palette.primary.main
  const activeKey = allCompleted ? 'success.main' : 'primary.main'

  return {
    dot: {
      bgcolor: completed ? activeKey : 'transparent',
      border: '2px solid',
      borderColor: completed ? activeKey : theme.palette.divider,
      borderRadius: '99999px',
      height: 12,

      ...(completed && { outline: '4px solid' }),
      outlineColor: completed ? alpha(activeColor, 0.25) : theme.palette.divider,

      width: 12,
    },
    connector: {
      bgcolor: completed ? activeKey : 'divider',
      height: 2,
      width: 61.33,
    },
  }
}
